var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',[_vm._v(" "+_vm._s(_vm.icons.mdiCheckCircle)+" ")]),_c('p',[_vm._v("เสร็จสิ้น")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }